var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-array',_vm._b({attrs:{"objs":_vm.items}},'h-array',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }